/** Add to Book Notes. A blank category is Unsorted, never a person. */

export const UNSORTED_NOTE_CATEGORY = 'Unsorted';

export function isSectionHeading(name) {
  let label = String(name || '').trim().toLowerCase().replace(/[:.]+$/, '');
  label = label.replace(/^#+\s*/, '');
  if (!label) return false;
  if (label.endsWith(' so far')) return true;
  return label === 'story elements' || label === 'story elements so far';
}

export function categoryForAddedNote(raw) {
  const text = String(raw || '').trim();
  return text || UNSORTED_NOTE_CATEGORY;
}
